import { useState, useEffect, useMemo, useLayoutEffect } from 'react';

import api from '../../apis';
import moment from 'moment';
import { usePagination } from './helper';

import ReactTable from '../general/form-control/react-table';
import { useGlobalVariable } from '../../context/GlobalVariableProvider';
import { useFilter } from '../../context/FilterContext';
import WithdrawalModal from '../modals/WithdrawalModal';
import { numberWithCommas } from '../general/convertor';

const TrustWithdrawalTbl = ({
    //accounts = []
    inputs={},
    requestOnRender=false,
    type=null
}:any) => {
   // const { initFilter,filterParams }:any = useGlobalVariable();
    const { filterParams } = useFilter();
    const { tablePagination, setTablePagination } = usePagination();
    const [tableData, setTableData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const [_inputs, _setInputs] = useState({});
  
    // useEffect(() => {
    //     if(requestOnRender == true){
    //         //alert("requestOnRender")
    //         handleFilter(filterParams)
    //     }
        
    // }, [requestOnRender]);



  
    useEffect(() => {
        handleFilter(filterParams)

    }, [filterParams]);

    const handleFilter = (filterParams:any)=>{
        //alert(JSON.stringify(filterParams))
        if(Object.keys(filterParams).length == 0) return;

        let accounts = filterParams["accounts[]"] ||[];

        //requestGetFundingHistoryAPI(accounts,filterParams,1);
       requestTableData(accounts,1,filterParams);
        _setInputs(filterParams);
        setAccounts(accounts);
    }



    const requestTableData = async (accounts:any,cPage=1,inputs:any={}) =>{
        if(accounts.length <1) {
            setTableData([])
            return 
        }

        setTableData([])
       // if(!orderNo)return;
        setLoading(true)
        let result = await api.getFundingTrust(
            accounts,
            inputs,
            cPage
        );

        if(result.trusts){
            //console.log("result.trusts",result.trusts)
            setTableData(result.trusts)
        }
        
        // if (result.total) {
        //     // handlePagination('currentPage', cPage);
        //     // handlePagination('totalRecords', result.total);
        //     setTablePagination({
        //         currentPage: cPage,
        //         totalRecords: result.total
        //     });
        // }

       setLoading(false)
        // console.log("getTradeHistoryLogs",result)
    }


    const tblColumns = useMemo(
        () => [
            {
                Header: 'Date',
                accessor: 'at_timeupdate', 
                Cell: (v: any) => {
                    if (v.value) return moment(v.value).format('DD/MM/YYYY');
                }
            },
            {
                Header: 'Reference',
                accessor: 'at_bankacctno', 
                Cell: ({ row }:any) => {
                    let rowData = row?.original;
                    let at_bankacctno = rowData.at_bankacctno || '';
                    let bk_name = rowData.bk_name || '';

                    return <> <div>{bk_name}</div><div>{at_bankacctno}</div></>
                }
            },
            {
                Header: 'Currency',
                accessor: 'c_code', 
            },
            {
                Header: 'Amount Deposited',
                accessor: 'at_trust_amt', 
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 3)}
                        </div>
                    );
                }
            },
            {
                Header: 'Balance Amount',
                accessor: 'at_balance_amt', 
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 3)}
                        </div>
                    );
                }
            },
            {
                Header: 'Accrual Interest',
                accessor: 'at_accured_interest', 
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 3)}
                        </div>
                    );
                }
            },
            {
                Header: 'Total',
                accessor: 'total', 
                Cell: ({ row }:any) => {
                    let rowData = row?.original;
                    let at_balance_amt = rowData.at_balance_amt || 0;
                    let interest = rowData.at_accured_interest || 0;

                    let total = at_balance_amt + interest;

                    return (
                        <div className="text-right">
                            {numberWithCommas(total, 3)}
                        </div>
                    );
                }
            },
            {
                Header: 'Amount Deposited (MYR)',
                accessor: 'at_trust_amt_baseccy', 
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 3)}
                        </div>
                    );
                }
            },
            {
                Header: 'Balance Amount (MYR)',
                accessor: 'at_balance_amt_baseccy', 
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 3)}
                        </div>
                    );
                }
            },
            {
                Header: 'Accrual Interest (MYR)',
                accessor: 'at_accured_interest_baseccy', 
                Cell: (v: any) => {
                    return (
                        <div className="text-right">
                            {numberWithCommas(v.value, 3)}
                        </div>
                    );
                }
            },
            {
                Header: 'Total (MYR)',
                accessor: 'total_myr', 
                Cell: ({ row }:any) => {
                    let rowData = row?.original;
                    let at_balance_amt = rowData.at_balance_amt_baseccy || 0;
                    let interest = rowData.at_accured_interest_baseccy || 0;

                    let total = at_balance_amt + interest;

                    return (
                        <div className="text-right">
                            {numberWithCommas(total, 3)}
                        </div>
                    );
                }
            },
        ],
        []
    );


    return (
        <>
            <ReactTable
                // headerStyle={{
                //     background: 'rgba(210, 209, 209, 1)',
                //     color:"black"
                // }}
                columns={tblColumns}
                data={tableData}
                loading={loading}
                size='small'
                borderSeparate={true}
               // pageSize={10}
                // currentPage={tablePagination.currentPage}
                // totalRecords={tablePagination.totalRecords}
                // pageChange={(cPage: number) => {
                //     // showNotiLoader();
                //     requestTableData(accounts, cPage,inputs);
                // }}
                // hasPagination

            />
            <div className='pt-3'>
                <WithdrawalModal onSubmit={()=> requestTableData(accounts, 1,inputs)}>
                    <button
                        className="btn-primary-custom btn-md"
                        // onClick={onSearchButtonClick}
                        style={{ width: '100%', maxWidth: '150px' }}
                    >Withdrawal</button>
                </WithdrawalModal>
            </div>
        </>
    );
};

export default TrustWithdrawalTbl;
